export default "__VITE_ASSET__mw6svo7x__"